<template>
  <v-app class="app-root">
    <v-main class="app-main">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
      <v-snackbar
        v-model="showSnackbar"
        bottom
        right
        :color="snackbar.color"
        class="global-snackbar"
        timeout="3500"
      >
        {{ snackbar.text }}
        <v-btn name="close" text dark @click="showSnackbar = false"
          >Close</v-btn
        >
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "App",
  data() {
    return {
      showSnackbar: false
    };
  },
  computed: {
    ...mapGetters({ snackbar: "getSnackbar" })
  },
  watch: {
    snackbar() {
      this.showSnackbar = true;
    }
  }
};
</script>
<style>
html {
  background: var(--paper);
  overflow-x: hidden;
}

@font-face {
  font-family: "Eurosoft";
  src: url("~@/../public/font/EurosoftMedium.woff2") format("woff2");
  font-display: swap;
}

:root {
  --ink: #1e292a;
  --muted: #6c7776;
  --paper: #f6f4ef;
  --white: #ffffff;
  --orange: #e95635;
  --orange-dark: #c84229;
  --accent: #4d5654;
  --accent-soft: #ecece6;
  --line: #deded8;
  --yellow: #f2c96d;
}

body {
  margin: 0;
  min-width: 320px;
  background: var(--paper);
  color: var(--ink);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  -webkit-font-smoothing: antialiased;
}

.app-root,
.app-main {
  min-height: 100vh !important;
  background: var(--paper) !important;
}

.app-main {
  padding: 0 !important;
}

.v-application,
.v-application .headline,
.v-application .title,
.v-application .body-1,
.v-application .body-2 {
  font-family: inherit !important;
}

.global-snackbar .v-snack__wrapper {
  border-radius: 14px !important;
  box-shadow: 0 14px 35px rgba(30, 41, 42, 0.2) !important;
  font-weight: 700;
}
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.5s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
